import { ISlideModel } from '../../../Interface/slide-model.interface';
import { LINK_IS_INVALID_FLAG } from '../constant';

export function getSlideUniqueIDBySelectedPPTTarget(selectedPPTTarget: number, slideList: ISlideModel[]) {
    const { uniqueID } = slideList[selectedPPTTarget - 1];
    return uniqueID;
}

export function getSlideTarget(slideJumpTarget: string, slideList: ISlideModel[]) {
    // 由于之前跳转至指定slide页依据的是slide列表的索引，需要对旧数据兜个底，使其根据索引跳转。
    const isOldData = slideJumpTarget.startsWith('/ppt/slides/slide');

    if (isOldData) {
        return slideJumpTarget.replace(/[^0-9]/g, '');
    }

    const slideIndex = slideList.findIndex(slideItem => slideItem?.uniqueID === slideJumpTarget);

    if (slideIndex < 0) {
        return LINK_IS_INVALID_FLAG;
    }

    return String(slideIndex + 1);
}
